module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"ticket.field.resolved_result.prefix":"ผลวิเคราะห์ : "}}')
  delete Component.options._Ctor
}
